















































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "@/services/general-service";
import config from "@/services/api-config";
import router from "@/router";
import "@/styles/question.scss";
import Answer from "@/components/Answer.vue";

@Component({
  components: { answer: Answer },
  props: ["questions", "answers", "shouldDisable", "shouldDisplay", "type"],
})
export default class Questions extends Vue {
  questions: QuestionE[];
  answers: any;
  shouldDisable: any;
  shouldDisplay: any;
  type: string | null;

  onChange() {
    window.scrollTo(0, 0);
  }

  findAnswer(question) {
    return this.answers.find((e) => e.questionId === question.qid);
  }

  data() {
    return {
      listStart: 1,
      shouldShow: function (index) {
        if ((this.listStart - 1) * 10 <= index && this.listStart * 10 > index) {
          return true;
        } else {
          return false;
        }
      },
    };
  }
}
